var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotoMapButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#5B7CFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29004 13.78V23.51C8.29004 25.41 9.64004 26.19 11.28 25.25L13.63 23.91C14.14 23.62 14.99 23.59 15.52 23.86L20.77 26.49C21.3 26.75 22.15 26.73 22.66 26.44L26.99 23.96C27.54 23.64 28 22.86 28 22.22V12.49C28 10.59 26.65 9.80998 25.01 10.75L22.66 12.09C22.15 12.38 21.3 12.41 20.77 12.14L15.52 9.51998C14.99 9.25998 14.14 9.27998 13.63 9.56998L9.30004 12.05C8.74004 12.37 8.29004 13.15 8.29004 13.78Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5601 10V23",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.73 12.62V26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoMapButton);
export default __webpack_public_path__ + "static/media/GotoMapButton.245e0b0655ef158cdc60f14c9a90e846.svg";
export { ForwardRef as ReactComponent };